<template>
    <div style="text-align: center;height: 50px;line-height: 50px;">签到、积分功能暂时关闭</div>
    <!-- <div class="clock-welfare" v-title="'福利活动中心'" v-if="details"> 
        <van-nav-bar fixed left-arrow :border="false" @click-left="finish">
            <template #title>
                <div>福利活动中心</div>
            </template>
        </van-nav-bar>
        <div class="integral-box">
            <div class="integral-num">
                <span>{{details.ResidueScore || 0}}</span>
                <i>速派积分</i>
            </div>
            <button class="link-gift" @click="linkPointsfor">兑换礼品</button>
        </div>
        <div class="clock-main">
            <div class="clock-time">
                <div class="date-left">
                    <label for="">七日签到</label>
                    <span>{{details.StartTime}} - {{details.EndTime}}</span>
                </div>
                <button class="btn-right" v-if="details.IsCanSign" @click="clickSign(1)">签到</button>
                <button class="no-btn-right" v-else>已签到</button>
            </div>
            <div class="clock-day">
                <ul class="item-up-day">
                    <template v-for="(item,index) in details.PersonSignList">
                        <li :key="index" :class="{'pass':item.SignStatus == 2}">
                            <span class="day-headline">{{item.StrDayCount}}</span>
                            <strong class="day-last-icon" v-if="item.IsBlindBox">图片</strong>
                            <strong class="day-mark" v-else>{{item.Score}}</strong>
                            <i class="icon-up-yes"></i>
                        </li>
                    </template>
                </ul>
                <ul class="item-down-day">
                    <template v-for="(item,index) in details.EngineerSignList">
                        <li :key="index" :class="{'pass':item.SignStatus == 2}">
                            <strong class="day-last-icon" v-if="item.IsBlindBox">图片</strong>
                            <strong class="day-mark" v-else>{{item.Score}}</strong>
                            <button class="day-btn" v-if="item.SignStatus == 4" @click="clickSign(2,item.SignConfigId)">领取</button>
                            <i class="icon-down-yes"></i>
                        </li>
                    </template>
                </ul>
            </div>
            <p class="tips">认证成为速派工程师可领取更多专属福利哦</p>
        </div>
        <div class="switch-main">
            <ul>
                <template v-for="(item,index) in taskLabelList">
                    <li :class="{'on':labelIndex == item.AccTaskGroupId}" :key="index" @click="labelSwitch(item,index)">{{item.TaskGroupName}}<i class="dot" v-if="item.PendingTackCount>0"></i></li>
                </template>
            </ul>
        </div>
        <div class="clock-task-main">
            <p class="tips">{{tips}}</p>
            <ul class="task-box">
                <li class="item-task" v-for="(item,index) in taskList" :key="index">
                    <div class="item-left">
                        <div class="items-icon">
                            <img :src="item.IconImgUrl" alt="icon">
                        </div>
                        <h4>{{item.Name}}</h4>
                        <p>{{item.Remark}}</p>
                    </div>
                    <div class="item-right">
                        <p class="items-complete">{{item.FinishCount}}/<template v-if="item.MaxDrawCount !=0">{{item.MaxDrawCount}}</template><template v-else><span style="font-size: 12px;">不限</span></template></p>
                        <button class="items-btn" v-if="item.TaskStatus == 0" @click="goToAll(item.TaskType)">去完成</button>
                        <button class="items-btn" v-else-if="item.TaskStatus == 2" @click="drawTaskPrize(item.AccTaskId)">领取</button>
                        <button class="items-no-btn" v-else-if="item.TaskStatus == 3">已领取</button>
                        <button class="items-no-btn" v-else>已完成</button>
                    </div>
                </li>
            </ul>
        </div>
        <div class="draw-all">
            <button @click="drawAllTaskPrize" v-if="isExist">一键领取</button>
            <button v-else style="background: #e5e5e5">一键领取</button>
        </div>
    </div> -->
</template>
<script>
    import {
        GetSignList,        // 获取签到列表
        Sign,               //签到
        GetTaskGroupList,   //获取分类
        GetTaskList,        //获取分类列表
        DrawTaskPrize,      //领取任务奖品
        DrawAllTaskPrize,   //一键领取
        GetEveryDayExamPaper,
    } from '@/common/api.js'
    import {
        mapState
    } from 'vuex'
    import bridge from '@/common/dsbridge.js';
    export default {
        data() {
            return {
                appUserInfo: null,              //app里的用户信息
                userid: Number,                 //app里的用户id 不带p
                isWeb: true,                    //是否是浏览器 true 是 false 否

                isShowWX: false,

                idx: 0,
                details: null,                  //tab以上信息
                taskLabelList: [],              //label
                labelIndex: '',
                taskList: [],
                tips: '',                       //提示文字

                isExist: false,                 //是否可以一键领取

            }
        },
        computed: {
            ...mapState({
                userData: state => state.userData,
                createConfig: state => state.createConfig,
            }),
        },
        created() {
            // bridge.register('getTitleInitData', function () {
            //     return '{"isShowTitleBar":false}'
            // });
            // this.isWeb=typeof(bridge.call('getUserInfo'))==='undefined'?true:false;
            // this.getUserInfo()
        },
        mounted() {
            // let self = this;
            // bridge.register('notifyLoginSuccess', function () {
            //     self.getUserInfo();
            // });
        },
        methods: {
            // 获取用户信息
            getUserInfo(){
                let info = bridge.call('getUserInfo') || null;
                
                info='{"userId":"p3561800"}'; 
                this.isWeb=false; 
                if(info) {
                    this.appUserInfo = JSON.parse(info);
                    if (this.appUserInfo.userId.indexOf('p') === 0) {
                        this.userid = Number(this.appUserInfo.userId.substr(1));
                    }
                }
                this.getSignList()
                this.getTaskGroupList()
            },
            // 返回签到列表
            getSignList(){
                let data = {}
                if(this.appUserInfo && !this.isWeb) {
                    data.UserId = this.userid
                }else if(this.userData && this.isWeb) {
                    // data.UserId = 3667598
                    data.UserId = this.userData.UserId
                }
                GetSignList(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$toast('请重新获取');
                    }
                    this.details = res.Data
                })
            },
            // 点击签到
            clickSign(is,id){
                let self = this
                if(is == 2 && !this.details.IsEngineer) {
                    return bridge.call('jumpApplyEngineer')
                }
                let data = {}
                if(this.appUserInfo && !this.isWeb) {
                    data.UserId = this.userid
                }else if(this.userData && this.isWeb) {
                    // data.UserId = 3667598
                    data.UserId = this.userData.UserId
                }
                if(is == 2) {
                    data.SignConfigId = id
                }
                Sign(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$toast(res.Message);
                    }
                    this.$toast.success('签到成功！');
                    setTimeout(()=>{
                        self.getSignList()
                    },2000)
                })
            },
            // 获取label
            getTaskGroupList(o){
                let data = {}
                if(this.appUserInfo && !this.isWeb) {
                    data.UserId = this.userid
                }else if(this.userData && this.isWeb) {
                    // data.UserId = 3667598
                    data.UserId = this.userData.UserId
                }
                GetTaskGroupList(data).then(res=>{
                    this.taskLabelList = JSON.parse(JSON.stringify(res.Data.List))
                    this.isExist = res.Data.IsExistPendingDrawTask
                    if(o!=1){
                        this.labelIndex = res.Data.List[0].AccTaskGroupId
                        this.tips = res.Data.List[0].Remark
                        this.getTaskList(res.Data.List[0])
                    }
                })
            },
            //点击切换label
            labelSwitch(row,index){
                this.idx = index
                this.labelIndex = row.AccTaskGroupId
                this.tips = row.Remark
                this.getTaskList(row)
                this.getTaskGroupList(1)
            },
            // 获取label 列表
            getTaskList(row){
                let data = {}
                if(this.appUserInfo && !this.isWeb) {
                    data.UserId = this.userid
                }else if(this.userData && this.isWeb) {
                    // data.UserId = 3667598
                    data.UserId = this.userData.UserId
                }
                data.TaskGroupType = row.TaskGroupType
                data.AccTaskGroupId = row.AccTaskGroupId
                GetTaskList(data).then(res=> {
                    this.taskList = res.Data
                })
            },














            // 返回
            finish() {
                bridge.call('finishWebView')
            },
            // 点击跳转到兑换礼品
            linkPointsfor() {
                var userId = ''
                if(this.appUserInfo && !this.isWeb) {
                    userId = this.userid
                }else if(this.userData && this.isWeb) {
                    userId = this.userData.UserId
                }
                this.$router.push({
                    path: '/pointsfor',
                    query: {
                        userId: userId
                    }
                });
            },


            // 点击领取
            drawTaskPrize(id){
                let data = {}
                data.AccTaskId = id
                DrawTaskPrize(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$toast(res.Message);
                    }
                    this.$toast.success('领取成功！');
                    setTimeout(()=>{
                        this.getTaskList(this.taskLabelList[this.idx])
                        this.getSignList()
                    },2000)
                })
            },
            // 点击去完成
            goToAll(type) {
                const MODE = process.env.VUE_APP_MODE
                var url = ''
                let data = {} 
                switch(type) {
                    case 1:     // 完成实名认证
                        bridge.call('jumpRealName')
                        break;
                    case 2:     // 完善资料
                        bridge.call('jumpUpdateUserInfo')
                        break;
                    case 3:     // 认证工程师
                        bridge.call('jumpApplyEngineer')
                        break;
                    case 4:     // 完成一场能力考试
                        bridge.call('goToExam')
                        break;
                    case 5:     // 完成一次投标
                        bridge.call('gotoOrderList')
                        break;
                    case 6:     // 首次发布帖子
                        bridge.call('createForum')
                        break;
                    case 7:     // 首次评论回帖
                        bridge.call('jumpForumList')
                        break;
                    case 8:     // 邀请好友认证
                        if (MODE == 'test') {
                            //预生产
                            url = 'http://tactivity.insupai.com';
                        }
                        if (MODE == 'production') {
                            //生产
                            url = 'http://activitys.insupai.com';
                        }
                        if (MODE == 'development') {
                            //测试
                            url = 'http://activity.gongkongbpo.qa';
                        }
                        var userId = ''
                        if(this.appUserInfo && !this.isWeb) {
                            userId = this.userid
                        }else if(this.userData && this.isWeb) {
                            userId = this.userData.UserId
                        }
                        bridge.call('openWebView',url+'/#/prizeDetail?userId='+userId)
                        // window.location.href = url+'/#/prizeDetail?userId='+userId
                        // window.open(url+'/#/prizeDetail?userId='+userId)
                        break;
                    case 9:     // 发布一个工单
                        bridge.call('createOrder')
                        break;
                    case 10:    // 发布帖子
                        bridge.call('createForum')
                        break;
                    case 11:    // 分享工单
                        bridge.call('gotoOrderList')
                        break;
                    case 12:    // 分享帖子
                        bridge.call('jumpForumList')
                        break;
                    case 13:    // 评论
                        bridge.call('jumpForumList')
                        break;
                    case 14:    // 点赞
                        bridge.call('jumpForumList')
                        break;
                    case 15:    // 每日答题挑战
                        if(this.appUserInfo && !this.isWeb) {
                            data.UserCode = 'p'+this.userid
                        }else if(this.userData && this.isWeb) {
                            data.UserCode = this.userData.UserCode
                        }
                        GetEveryDayExamPaper(data).then(res=>{
                            if(res.Result != 1) {
                                return this.$toast(res.Message);
                            }
                            bridge.call('openEveryDayExam',res.Data)
                        })
                        break;
                }
            },
            // 一键领取
            drawAllTaskPrize(){
                let data = {}
                if(this.appUserInfo && !this.isWeb) {
                    data.userId = this.userid
                }else if(this.userData && this.isWeb) {
                    data.userId = this.userData.UserId
                }
                DrawAllTaskPrize(data).then(res=>{
                    if(res.Result != 1) {
                        return this.$toast(res.Message);
                    }
                    this.$toast.success('领取成功！');
                    setTimeout(()=>{
                        this.getTaskList(this.taskLabelList[this.idx])
                        this.getSignList()
                    },2000)
                })
            }
        },
    }
</script>
<style lang="scss">
    @import '~@/style/_base.scss';

    .clock-welfare {
        padding-top: px2rem(148px);
        @include bg('~@/assets/clock/head-clock-bg.png');
        background-position: top center;
        background-size: 100% px2rem(440px);
        min-height: 100vh;

        // .head {
        //     position: fixed;
        //     left: 0;
        //     top: 0;
        //     width: 100%;
        //     height: px2rem(60px);
        //     @include bg('~@/assets/clock/head-clock-bg.png');
        //     background-position: left top;
        //     background-size: cover;
        //     overflow: hidden;
        //     z-index: 2;
        // }
        .van-nav-bar--fixed {
            @include bg('~@/assets/clock/head-clock-bg.png');
            // background-position: left -30px !important;
            background-position: left 0 !important;
            background-size: cover;
            // top: px2rem(60px);
            top: 0;
            background-color: transparent !important;
            // height: px2rem(88px);
            height: px2rem(158px);
            padding-top: px2rem(70px);

            .van-nav-bar__content {
                height: px2rem(88px);
            }

            i,
            div {
                color: #ffffff;
            }

            i:before {
                color: #ffffff;
            }
        }

        .integral-box {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            height: px2rem(120px);
            margin-bottom: px2rem(30px);

            .integral-num {
                >* {
                    display: block;
                    text-align: center;
                    color: #ffffff;
                }

                span {
                    font-size: px2rem(62px);
                    font-weight: 600;
                    line-height: 38px;
                }

                i {
                    font-size: px2rem(24px);
                }
            }

            .link-gift {
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                background: #FF7748;
                border-radius: px2rem(24px) 0px 0px px2rem(24px);
                width: px2rem(160px);
                height: px2rem(48px);
                font-size: px2rem(24px);
                color: #ffffff;
            }
        }

        .clock-main {
            margin: 0 px2rem(28px);
            padding: px2rem(15px) px2rem(28px);
            background: #ffffff;
            box-shadow: 0px 10px 23px 1px rgba(0, 0, 0, 0.04);
            border-radius: 20px;

            .clock-time {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: px2rem(19px);

                .date-left {
                    label {
                        font-size: px2rem(32px);
                        font-weight: 600;
                        color: #333333;
                    }

                    span {
                        font-size: px2rem(24px);
                        color: #999999;
                        margin-left: px2rem(30px);
                    }
                }

                button {
                    height: px2rem(62px);
                    width: px2rem(140px);
                    font-size: px2rem(26px);
                    color: #ffffff;
                    line-height: px2rem(62px);
                    border-radius: px2rem(31px);
                }

                .btn-right {
                    background: linear-gradient(88deg, #FF7216, #FF3E15);
                }

                .no-btn-right {
                    background: #999999;
                }
            }

            .clock-day {
                ul {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: px2rem(13px);

                    li {
                        min-width: px2rem(82px);
                        max-width: px2rem(82px);
                        height: px2rem(116px);
                        position: relative;
                        background: #F3F3F3;
                        border-radius: px2rem(10px);

                        >* {
                            display: block;
                        }

                        span.day-headline {
                            font-size: px2rem(22px);
                            line-height: px2rem(46px);
                            color: #999999;
                            text-align: center;
                            white-space: nowrap;
                        }

                        .day-mark {
                            font-size: px2rem(26px);
                            color: #333333;
                            font-weight: bold;
                            font-family: DIN;
                            position: absolute;
                            top: 58%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }

                    li.pass {
                        background: #FAFAFA;
                        .day-mark {
                            display: none;
                        }
                        i {
                            display: block;
                            width: px2rem(36px);
                            height: px2rem(24px);
                            position: absolute;
                            left: 50%;
                            top: px2rem(52px);
                            transform: translateX(-50%);
                        }

                        i.icon-up-yes {
                            @include bg('~@/assets/clock/up-pass.png');
                        }

                        i.icon-down-yes {
                            @include bg('~@/assets/clock/down-pass.png');
                        }
                    }
                }
                .day-last-icon {
                    width: px2rem(54px);
                    height: px2rem(36px);
                    @include bg('~@/assets/clock/icon-day-7.png');
                    font-size: 0;
                    position: absolute;
                    left: 50%;
                    top: px2rem(32px);
                    transform: translateX(-50%);
                }
                
                .item-up-day {
                    li {
                        &::after {
                            content: '';
                            width: px2rem(6px);
                            height: px2rem(35px);
                            @include bg('~@/assets/clock/clock-line.png');
                            position: absolute;
                            left: 50%;
                            transform: translateX(-50%);
                            bottom: px2rem(-24px);
                            display: block;
                            z-index: 2;
                        }
                    }
                    .day-last-icon {
                        top: px2rem(52px);
                    }
                }
                
                .item-down-day {
                    li {
                        .day-mark {
                            top: 44%;
                        }

                        .day-btn {
                            position: absolute;
                            left: 50%;
                            bottom: px2rem(12px);
                            transform: translateX(-50%);
                            width: px2rem(70px);
                            height: px2rem(30px);
                            color: #ffffff;
                            font-size: px2rem(22px);
                            line-height: px2rem(20px);
                            background: linear-gradient(88deg, #FF7216, #FF3E15);
                            border-radius: px2rem(15px);
                        }
                    }

                    li:first-child {
                        @include bg('~@/assets/clock/engineer-icon-1.png');
                    }

                    li:nth-child(2) {
                        @include bg('~@/assets/clock/engineer-icon-2.png');
                    }

                    li:nth-child(3) {
                        @include bg('~@/assets/clock/engineer-icon-3.png');
                    }

                    li:nth-child(4) {
                        @include bg('~@/assets/clock/engineer-icon-4.png');
                    }

                    li:nth-child(5) {
                        @include bg('~@/assets/clock/engineer-icon-5.png');
                    }

                    li:nth-child(6) {
                        @include bg('~@/assets/clock/engineer-icon-6.png');
                    }

                    li:last-child {
                        @include bg('~@/assets/clock/engineer-icon-7.png');
                    }

                    li.pass:first-child {
                        @include bg('~@/assets/clock/engineer-icon-pass-1.png');
                    }

                    li.pass:nth-child(2) {
                        @include bg('~@/assets/clock/engineer-icon-pass-2.png');
                    }

                    li.pass:nth-child(3) {
                        @include bg('~@/assets/clock/engineer-icon-pass-3.png');
                    }

                    li.pass:nth-child(4) {
                        @include bg('~@/assets/clock/engineer-icon-pass-4.png');
                    }

                    li.pass:nth-child(5) {
                        @include bg('~@/assets/clock/engineer-icon-pass-5.png');
                    }

                    li.pass:nth-child(6) {
                        @include bg('~@/assets/clock/engineer-icon-pass-6.png');
                    }

                    li.pass:last-child {
                        @include bg('~@/assets/clock/engineer-icon-pass-7.png');
                    }
                }
                .pass {
                    .day-last-icon {
                        opacity: 0.4;
                    }
                }
            }

            .tips {
                font-size: px2rem(24px);
                color: #999999;
                line-height: px2rem(50px);
            }
        }

        .switch-main {
            margin-top: px2rem(60px);

            ul {
                display: flex;
                margin: 0 px2rem(44px);

                li {
                    flex: 0 0 33.33%;
                    box-sizing: border-box;
                    padding: 0 5%;
                    font-size: px2rem(32px);
                    color: #333333;
                    font-weight: bold;
                    line-height: px2rem(62px);
                    position: relative;
                    text-align: center;
                    height: px2rem(62px);

                    .dot {
                        position: absolute;
                        top: 10%;
                        right: 18%;
                        -webkit-transform: translate(50%, -50%);
                        transform: translate(50%, -50%);
                        -webkit-transform-origin: 100%;
                        transform-origin: 100%;
                        width: px2rem(12px);
                        min-width: 0;
                        height: px2rem(12px);
                        background-color: #f75959;
                        border-radius: 100%;
                    }
                }

                li.on {
                    color: #f75959;

                    &::after {
                        content: '';
                        width: 45%;
                        height: px2rem(6px);
                        border-radius: px2rem(3px);
                        position: absolute;
                        bottom: px2rem(-6px);
                        left: 50%;
                        transform: translateX(-50%);
                        background: #f75959;
                    }

                    .dot {
                        display: none;
                    }
                }
            }
        }

        .clock-task-main {
            margin: 0 px2rem(28px);
            padding-top: px2rem(93px);
            padding-bottom: px2rem(60px);
            position: relative;

            .tips {
                position: absolute;
                top: px2rem(6px);
                left: 0;
                font-size: px2rem(26px);
                color: #999999;
                line-height: px2rem(87px);
            }

            .task-box {
                background: #FFFFFF;
                box-shadow: 0px 10px 23px 1px rgba(0, 0, 0, 0.04);
                border-radius: px2rem(20px);
                padding: 0 px2rem(28px) px2rem(20px);

                li.item-task {
                    min-height: px2rem(174px);
                    border-bottom: 1px solid #e6e6e6;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .item-left {
                        position: relative;
                        padding-left: px2rem(108px);

                        .items-icon {
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            width: px2rem(88px);
                            height: px2rem(88px);

                            img {
                                display: block;
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }

                        h4 {
                            font-size: px2rem(30px);
                            color: #333333;
                            font-weight: 500;
                            line-height: px2rem(40px);
                        }

                        p {
                            color: #fea828;
                            font-size: px2rem(26px);
                            font-weight: 400;
                            line-height: px2rem(26px);
                            padding-top: px2rem(18px);
                        }
                    }

                    .item-right {
                        text-align: right;

                        .items-complete {
                            font-size: px2rem(30px);
                            color: #333333;
                            margin-right: px2rem(20px);
                            line-height: px2rem(30px);
                            margin-bottom: px2rem(14px);
                            span {
                                display: inline-block;
                                vertical-align: top;
                                line-height: px2rem(30px);
                            }
                        }

                        button {
                            width: px2rem(178px);
                            height: px2rem(62px);
                            text-align: center;
                            border-radius: px2rem(31px);
                            color: #ffffff;
                            font-size: px2rem(26px);
                        }

                        .items-btn {
                            background: linear-gradient(88deg, #FF7216, #FF3E15);
                        }

                        .items-no-btn {
                            background: #999999;
                        }
                    }
                    &:last-child {
                        border-bottom: none;
                    }
                }
            }
        }

        .draw-all {
            display: flex;
            justify-content: center;
            padding-bottom: px2rem(60px);
            button {
                width: px2rem(240px);
                height: px2rem(80px);
                border-radius: px2rem(40px);
                background: linear-gradient(88deg, #FF7216, #FF3E15);
                color: #ffffff;
            }
        }
    }
</style>